/* The Box House — scroll reveals + ticker loop. Scoped to .tbh sections only. */
(function () {
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.tbh-reveal:not(.tbh-in), .tbh-stagger:not(.tbh-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tbh-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tbh-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTickers(root) {
    (root || document).querySelectorAll('.tbh-ticker-track:not([data-tbh-doubled])').forEach(function (t) {
      t.setAttribute('data-tbh-doubled', '1');
      t.innerHTML += t.innerHTML;
    });
  }

  function boot(root) { initReveals(root); initTickers(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Re-run inside the theme editor when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
